// extracted by mini-css-extract-plugin
export var growableInput = "_9s-0";
export var tagContainer = "_9s-2";
export var textInput = "_9s-1";